(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('LogisticsListController', LogisticsListController);

    LogisticsListController.$inject = [
		'$scope',
		'$state',
        'ordersService',
        '$templateCache',
        '$timeout',
        '$filter',
        'genericDataService',
        '$rootScope',
        'preferences',
		'$window',
		'fleet',
        'reportService',
        'notificationService',
        'simpleModalService',
        'common',
        'restrictionService'

    ];

    /* jshint maxstatements:false */
    /* jshint maxparams:false */
    function LogisticsListController(
		$scope,
		$state,
        ordersService,
        $templateCache,
        $timeout,
        $filter,
        genericDataService,
        $rootScope,
        preferences,
		$window,
		fleet,
        reportService,
        notificationService,
        simpleModalService,
        common,
        restrictionService
    ) {

        /* PRIVATE VARIABLES */
        //Hide the expand all rows button on the grid header
        if ($templateCache.get('ui-grid/expandableTopRowHeader') !== '<div class=\"ui-grid-row-header-cell\"></div>') {
            var savedTemplate = $templateCache.get('ui-grid/expandableTopRowHeader');
            $templateCache.put('ui-grid/expandableTopRowHeader', '<div class=\"ui-grid-row-header-cell\"></div>');
            //Restore the default template
            $scope.$on('$destroy', function () {
                $templateCache.put('ui-grid/expandableTopRowHeader', savedTemplate);
            });
        }

        var templates = {
            rowTemplate: $templateCache.get('app/views/tablesTemplates/logistics/rowTemplate.html'),
            subRowTemplate: $templateCache.get('app/views/tablesTemplates/logistics/subRowTemplate.html'),
            statusTemplate: $templateCache.get('app/views/tablesTemplates/logistics/statusCellTemplate.html'),
            accionesCellTemplate: $templateCache.get('app/views/tablesTemplates/logistics/accionesCellTemplate.html'),
            expandableTemplate: $templateCache.get('app/views/tablesTemplates/logistics/expandableTemplate.html'),
            headerTemplate: $templateCache.get('app/views/tablesTemplates/logistics/customHeaderTemplate.html'),
            ubicacionRec: $templateCache.get('app/views/tablesTemplates/generic/ubicacionRecTemplate.html'),
            ubicacionEnt: $templateCache.get('app/views/tablesTemplates/generic/ubicacionEntTemplate.html')
        };

        var paginationOptions = {
            pageNumber: 1,
            pageSize: 25,
            sort: { field: 'date', direction: 'desc' }
        };

        var sorting = {
            field: 'date',
            direction: 'asc'
        };

        var expandedRow = null;


        /* PUBLIC VARIABLES */
		var vm = this;
		vm.isNuevas = false;
        vm.restrictionService = restrictionService; 

        vm.onDateRangeChange = onDateRangeChange;
        vm.dateRange = $.extend({}, common.defaultDateRangePickerOptions);

        vm.searchText = '';
		vm.clearSearcher = clearSearcher;
		vm.fleet = fleet;

        //Grid
        $scope.gridData = null;
        vm.gridApi = null;
        vm.focusedRow = null;
        vm.loadingInformation = true;
        vm.gridOptions = {
            rowTemplate: templates.rowTemplate,

            enableGridMenu: true,

            enableHorizontalScrollbar: 0,

            expandableRowTemplate: templates.expandableTemplate,
            expandableRowHeight: 150,

            paginationPageSizes: [25, 50, 75],
            paginationPageSize: 25,
            useExternalPagination: true,
            useExternalSorting: true,

            enableRowSelection: true,
            multiSelect: true,

            enableColumnResizing: true,

            enableColumnMenus: false,
            treeRowHeaderAlwaysVisible: false,
            virtualizationThreshold: 200,

            primaryKey: 'orderId',

            columnDefs: [
                {
                    field: 'estadoLogistica',
                    displayName: 'Estado',
                    minWidth: 75,
                    maxWidth: 100,
                    resizable: true,
                    cellTemplate: templates.statusTemplate,
                    headerCellTemplate: templates.headerTemplate
                },
                {
                    field: 'nombreEmpresa',
                    displayName: 'Empresa',
                    minWidth: 120,
                    maxWidth: 180,
                    resizable: true,
                    headerCellTemplate: templates.headerTemplate
                },
                {
                    field: 'date',
                    displayName: 'Fecha',
                    minWidth: 100,
                    maxWidth: 125,
                    resizable: true,
                    cellFilter: 'date: "dd/MM/yyyy HH:mm"',
                    sort: { priority: 1, direction: 'desc' },
                    headerCellTemplate: templates.headerTemplate
                },
                {
                    field: 'jobOrder',
                    displayName: 'Nº Pedido',
                    minWidth: 90,
                    maxWidth: 125,
                    resizable: true,
                    headerCellTemplate: templates.headerTemplate
                },
                {
                    field: 'clientName',
                    displayName: 'Cliente',
                    minWidth: 70,
                    maxWidth: 180,
                    resizable: true,
                    headerCellTemplate: templates.headerTemplate
                },
                {
                    field: 'expedient',
                    displayName: 'Expediente',
                    minWidth: 90,
                    maxWidth: 130,
                    resizable: true,
                    headerCellTemplate: templates.headerTemplate
                },
                {
                    field: 'tipoOrdenDescripcion',
                    displayName: 'Tipo',
                    minWidth: 150,
                    maxWidth: 180,
                    resizable: true,
                    headerCellTemplate: templates.headerTemplate
                },
                {
                    field: 'pickupAddress',
                    displayName: 'Origen',
                    resizable: true,
                    cellTemplate: templates.ubicacionRec,
                    headerCellTemplate: templates.headerTemplate
                },
                {
                    field: 'deliveryAddress',
                    displayName: 'Destino',
                    resizable: true,
                    cellTemplate: templates.ubicacionEnt,
                    headerCellTemplate: templates.headerTemplate
                },
                {
                    name: 'acciones',
                    displayName: 'Acciones',
                    resizable: true,
                    width: 150,
                    cellClass: 'overflow',
                    cellTemplate: templates.accionesCellTemplate,
                    enableHiding: false,
                    enableSorting: false
                }
            ],
            data: 'gridData',
            onRegisterApi: function (gridApi) {
                vm.gridApi = gridApi;
                vm.gridApi.grid.options.enableExpandAll = false;

                vm.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
                    if (sortColumns.length > 0) {
                        sorting.field = sortColumns[0].field;
                        sorting.direction = sortColumns[0].sort.direction;
                    } else {
                        sorting = { field: null, direction: null };
                    }
                    getOrdersData();
                });
                vm.gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                    paginationOptions.pageNumber = newPage;
                    paginationOptions.pageSize = pageSize;

                    getOrdersData();


                });
                vm.gridApi.expandable.on.rowExpandedStateChanged($scope, function (row) {

                    if (row.isExpanded) {

                        if (expandedRow) {
                            vm.gridApi.expandable.toggleRowExpansion(expandedRow.entity);
                        }

                        expandedRow = row;
                        row.entity.subGridOptions = {
                            enableColumnMenus: false,
                            enableColumnResizing: false,
                            columnDefs: [
                                {
                                    field: 'marca',
                                    displayName: 'Marca'
                                }, {
                                    field: 'modelo',
                                    displayName: 'Modelo'
                                }, {
                                    field: 'color',
                                    displayName: 'Color'
                                }, {
                                    field: 'matricula',
                                    displayName: 'Matricula'
                                }, {
                                    field: 'fechaRec',
                                    displayName: 'Fecha recogida',
                                    cellFilter: 'date: "dd/MM/yyyy HH:mm"'
                                }, {
                                    field: 'fechaEnt',
                                    displayName: 'Fecha entrega',
                                    cellFilter: 'date: "dd/MM/yyyy HH:mm"'
                                }
                            ]
                        };

                        ordersService.getLogInternalOrders(row.entity.id).then(function (response) {
                            row.entity.subGridOptions.data = response.data;
                        });

                        row.entity.subGridOptions.onRegisterApi = function (subGridApi) {
                            $scope.$on('detail-resize', function (event, args) {
                                $timeout(function () {
                                    subGridApi.core.handleWindowResize();
                                }, 100);
                            });
                        };

                    }
                    else {
                        expandedRow = null;
                    }
                });
                vm.gridApi.core.on.columnVisibilityChanged($scope, function (changedColumn) {
                    saveColumnsVisibilityState();
                });
            }
        };

        //Filters
        vm.appliedFilters = []; //Filters that are currently applied to the data
        vm.selectedReport = 'albaran';
        var filtersJSON = null;
        vm.predefinedFilter = { name: 'Personalizado', filter: null };
        vm.predefinedFilters = [];

        vm.logEstados = [{ nombre: 'Pendiente', id: 0 }, { nombre: 'Completado', id: 1 }];
        vm.getClientsData = genericDataService.getClients;
        vm.getEmpresasData = genericDataService.getEmpresas;
        vm.fields = [
            //Default filters to appear

            {
                default: true, display: 'Estado', type: 'multi',
                field: 'estadoLogistica', data: 'logEstados'
            },
            { default: true, display: 'Fecha', type: 'date', field: 'date' },
            {
                default: true, display: 'Cliente', type: 'multi', field: 'clienteId',
                getData: 'getClientsData'
            },
            { default: true, display: 'Expedient.', type: 'string', field: 'expedient' },
            { default: true, display: 'Matrícula', type: 'string', field: 'plate' },
            { default: true, display: 'Nº pedido', type: 'string', field: 'jobOrder' },

            { default: true, display: 'Empresa', type: 'multi', field: 'empresaId', getData: 'getEmpresasData' },


            //Rest of possible filters
            // {display: 'Operarios', type: 'multi', field: 'operarioId', getData: genericDataService.getOperarios},
        ];
        vm.frequencyFields = computeFreqFieldsByOrderType();
        vm.filterControl = {};
		vm.reportService = reportService;
		vm.ordersService = ordersService;
		vm.acceptOrRejectOrder = acceptOrRejectOrder;

        vm.tab = $rootScope.tabManager.tabs[$rootScope.tabManager.indexOfName('logistica')];

        /* PUBLIC FUNCTIONS */

		//$rootScope.$state = $state;

        vm.getOrdersData = getOrdersData;
        vm.isFiltered = isFiltered;
        vm.applyFilter = applyFilter;
        vm.selectAll = selectAll;
        vm.clearAll = clearAll;
        vm.selectOrClear = selectOrClear;
        vm.invertSelection = invertSelection;
		vm.showHideFilterBar = showHideFilterBar;
        vm.goToEdit = goToEdit;
        vm.getColorEstado = getColorEstado;
        vm.filterChange = filterChange;
        vm.saveFilter = saveFilter;
        vm.setPredefinedFilter = setPredefinedFilter;
        vm.remove = remove;
        vm.changeOrderState = changeOrderState;
        vm.removeAllPedidos = removeAllPedidos;
        vm.refreshData = refreshData;
        vm.deleteFilter = deleteFilter;
        vm.deleteSearchData = deleteSearchData;

        vm.rowCount = 0;
        vm.firstLoaded = false;

		vm.refreshing = false;

		//traslados amounts
		vm.newLogisticsCount = null;

        /* INITIALIZER */
		(function () {

			vm.isNuevas = $state.current.data.isNuevas;

            var state = $rootScope.stateStorage[vm.tab.name];

            if (state && vm.tab.keepState) {
                $timeout(function () {
                    vm.searchText = state.search || '';
                    vm.focusedRow = state.focusedRow || null;
                    if (state.filters) {
                        vm.filterControl.setPredefinedFilters(state.filters);
                    }
                }, 0);
            } else {
                vm.getOrdersData();
			}

            getPredefinedFilters();
			setColumnVisibility();

        })();

        $scope.$on('detail-resize', function (event, args) {
            if (vm.tab.isActive()) {
                $timeout(function () { vm.gridApi.core.handleWindowResize(); }, 0);
            }
		});

		


        /* FUNCTION DEFINITIONS */
		function getOrdersData(success) {
            var skip = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
            var take = paginationOptions.pageSize;
			vm.loadingInformation = false;


			ordersService.getLogOrders(skip, take, sorting, vm.appliedFilters, vm.frequencyFields, vm.searchText,
				vm.isNuevas ? moment("1970-01-01") : vm.dateRange.fromDate, vm.isNuevas ? moment() : vm.dateRange.toDate,
				vm.isNuevas ? 1 : 20, vm.isNuevas ? 1 : 160)
				.then(function (result) {
					$scope.gridData = result.data.list;
					//console.log($scope.gridData);
					vm.gridOptions.totalItems = result.data.count;
					vm.rowCount = vm.gridOptions.totalItems;
					
                    vm.firstLoaded = true;
                    vm.refreshing = false;
                    if (success) {
                        notificationService.sendAppNotification({
                            message: 'Pedidos eliminados con éxito',
                            positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                        });
                    }
                    vm.loadingInformation = true;
                    /*
                    var selected = vm.gridApi.selection.getSelectedRows();
                    vm.clearAll();
                    var list = $scope.gridData;
                    for (var i = 0; i < list.length; i++) {
                        var found = $filter('filter')(selected, { 'orderId': list[i].orderId });
                        if (found[0]) {
                            vm.gridApi.grid.modifyRows($scope.gridData);
                            vm.gridApi.selection.selectRow($scope.gridData[i]);
                        }
                    }*/
                }
                );
		}

		function acceptOrRejectOrder(orderId, accept) {
			var state = accept ? 100 : 2;
			ordersService.setEstadoAsignacionOrder(orderId, state)

			for (var i = 0; i < $scope.gridData.length; ++i) {
				if ($scope.gridData[i].id == orderId) {
					$scope.gridData.splice(i, 1);
				}
			}
			//vm.isNuevas = false;
			//getOrdersData();
		}

        function remove(order) {
            if (!restrictionService.hasPermission('eliminar', 'ordenLOG')) return; 

            if (order == null) { return; }
            simpleModalService.yesNoModal('Confirmación eliminar',
                '¿Desea eliminar el pedido?')
                .then(function (result) {
                    if (result) {
                        notificationService.sendAppNotification({
                            message: 'Eliminando pedido...',
                            positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
                        });
                        ordersService.deleteOrderLog([order.id]).then(function () {
                            refreshData(true);
                        }, function () {
                            notificationService.sendAppNotification({
                                message: 'Ha ocurrido un error al eliminar los pedidos',
                                positionY: 'top', positionX: 'right', delay: null, type: 'error'
                            });
                        });
                    }
                });
        }

        function changeOrderState(orderId, state) {
            ordersService.legacyChangeOrderState(orderId, state)
                .then(function () {
                    getOrdersData();
                });
        }

        /* FILTROS */
        function getPredefinedFilters() {
            filtersJSON = $window.localStorage['filtersLog'];
            getFiltersFromJSON();
        }

        function getFiltersFromJSON() {
            vm.predefinedFilters = angular.fromJson(filtersJSON) || [];
            angular.forEach(vm.predefinedFilters, function (value, key) {
                if (value.type === 'date') {
                    value.input1 = value.input1 && new Date(value.input1);
                    value.input2 = value.input2 && new Date(value.input2);
                }
            });
        }

        function applyFilter(filters) {
            vm.appliedFilters = filters;
            getOrdersData();
        }

        function saveFilter(filterName, filters) {
            deleteFilter(filterName);

            var predefinedFilters = angular.fromJson($window.localStorage['filtersLog']) || [];
            predefinedFilters.push({ name: filterName, filter: filters });
            $window.localStorage.setItem('filtersLog', angular.toJson(predefinedFilters));

            getPredefinedFilters();
        }

        function deleteFilter(name) {
            var predefinedFilters = angular.fromJson($window.localStorage['filtersLog']) || [];
            var newFilters = predefinedFilters.filter(function (obj) {
                return obj.name !== name;
            });
            $window.localStorage.setItem('filtersLog', angular.toJson(newFilters));
            getPredefinedFilters();
        }

        function filterChange() {
            vm.predefinedFilter = { name: 'Personalizado', filter: null };
        }

        function setPredefinedFilter(selectedFilter) {
            vm.filterControl.setPredefinedFilters(selectedFilter.filter);
            getFiltersFromJSON();

            $timeout(function () {
                vm.predefinedFilter = selectedFilter;
            }, 0);
        }

        $scope.$on('$destroy', function () { //Save state
            var filters = vm.filterControl.getFilters();
            $rootScope.stateStorage[vm.tab.name] = {
                filters: filters,
                search: vm.searchText,
                focusedRow: vm.focusedRow
            };
        });

        /* HIDE/SHOW COLUMS */
        function saveColumnsVisibilityState() {
            var columns = [];
            angular.forEach(vm.gridOptions.columnDefs, function (value, key) {
                columns.push({ displayName: value.displayName, visible: value.visible === false ? false : true });
            });
            $window.localStorage.setItem('colVisibilityLog', angular.toJson(columns));
        }

        function setColumnVisibility() {
            var columns = angular.fromJson($window.localStorage['colVisibilityLog']) || [];
            if (!columns) { return; }
            angular.forEach(vm.gridOptions.columnDefs, function (value, key) {
                var col = $filter('filter')(columns, { displayName: value.displayName })[0];
                if (col) {
                    value.visible = col.visible !== false;
                }
            });
        }

        function showHideFilterBar() {
            vm.filtersSidebar = !vm.filtersSidebar;
            $rootScope.$broadcast('detail-resize');
        }

        function isFiltered(field) {
            for (var i = 0; i < vm.appliedFilters.length; i++) {
                if (vm.appliedFilters[i].input !== null) {
                    if (vm.appliedFilters[i].field === field) {
                        return true;
                    }
                }
            }
            return false;
		}

		/* SignalR CRUD */

		$(window).on('active-orders-update', function (e, args) {

			//console.log(args);
			if (common.isNullOrUndefined(args.orders))
				return;

			if (common.isNullOrUndefined($scope.gridData))
				$scope.gridData = [];

			for (var i = 0; i < args.orders.length; i++) {
				if (args.orders[i].tipo == 2) { 
					if (args.orders[i].changed == true) {
						var found = false;
						for (var j = 0; j < $scope.gridData.length; j++) {
							if ($scope.gridData[j].orderId == args.orders[i].orderId) {
								found = true;
								if (orderBelongsHere(args.orders[i])) {
									$scope.gridData[j] = args.orders[i];
								}
								else {
									$scope.gridData.splice(j, 1);
								}
								break; //Stop this loop, we found it!
							}
						}
						if (!found && orderBelongsHere(args.orders[i]))
							$scope.gridData.push(args.orders[i]);
						break;
					}
					else {
						if (orderBelongsHere(args.orders[i]))
							$scope.gridData.push(args.orders[i]);
					}		
				}
			}
			$(window).trigger('active-orders-update-setGridData');
		});

		function orderBelongsHere(order)
		{
			return (vm.isNuevas && order.estadoOrden == 1) || (!vm.isNuevas && order.estadoOrden >= 20 && order.estadoOrden <= 160);
		}

		$(window).on('removed-order', function (e, args) {
			$scope.gridData.splice($scope.gridData.indexOf(x => x.orderId == args), 1);
			$(window).trigger('active-orders-update-setGridData');
			//Se tendría que hacer lo del digest acá?
			//vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
		});

        /* ROW SELECTION */
        function selectAll() {
            vm.gridApi.selection.selectAllRows();
        }

        function clearAll() {
            vm.gridApi.selection.clearSelectedRows();
        }

        function invertSelection() {
            var selected = vm.gridApi.selection.getSelectedRows();
            vm.selectAll();
            for (var i = 0; i < selected.length; i++) {
                vm.gridApi.selection.unSelectRow(selected[i]);
            }
        }

        function selectOrClear() {
            if (vm.gridApi.selection.getSelectAllState()) {
                vm.clearAll();
            } else {
                vm.selectAll();
            }
        }

        function goToEdit(orderId) {
            vm.focusedRow = orderId;
            restrictionService.hasPermission('modificar', 'ordenLOG', 'flota.logistica.editar', { 'id': orderId });

            //$state.go('flota.logistica.editar', { 'id': orderId });
        }

        function getColorEstado(estado, row) {
            return preferences.prefs.getStateColor(estado) || 'undefined';
        }

        function removeAllPedidos() {
            if (!restrictionService.hasPermission('eliminar', 'ordenLOG')) return; 

            simpleModalService.yesNoModal('Confirmación eliminar',
                '¿Desea eliminar los ' + vm.gridApi.selection.getSelectedCount() + ' pedidos seleccionados?')
                .then(function (result) {
                    if (result) {
                        var pedidosIds = [];
                        var selected = vm.gridApi.selection.getSelectedRows();
                        for (var i = 0; i < selected.length; i++) {
                            pedidosIds.push(selected[i].orderId);
                        }
                        notificationService.sendAppNotification({
                            message: 'Eliminando pedido...',
                            positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
                        });
                        ordersService.deleteOrderLog(pedidosIds)
                            .then(function () {
                                refreshData(true);
                            },
                                function () {
                                    notificationService.sendAppNotification({
                                        message: 'Ha ocurrido un error al eliminar los pedidos',
                                        positionY: 'top', positionX: 'right', delay: null, type: 'error'
                                    });
                                });
                    }
                    selectOrClear();
                });
        }

        function refreshData(success) {
            vm.refreshing = true;
            getOrdersData(success);
        }

        function clearSearcher() {
            vm.searchText = '';
            refreshData();
        }

        function computeFreqFieldsByOrderType() {
            if (preferences.prefs.sector === 'GRU') {
                return ['expedient', 'plate', 'jobOrder'];
            }
            else if (preferences.prefs.sector === 'TAX') {
                return ['expedient', 'plate', 'jobOrder'];
            }
        }

        function deleteSearchData() {
            vm.searchText = '';
        }

        function onDateRangeChange() {
            refreshData();
        }

    }

})();
